import script from "./ViewHtmlSiglas.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHtmlSiglas.vue?vue&type=script&setup=true&lang=js"

import "./ViewHtmlSiglas.vue?vue&type=style&index=0&id=3e323916&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e323916"]])

export default __exports__